import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, Data } from '@angular/router';

import { HisBaseGlobalsService } from '../../core/service/base/his-base-globals.service';
import { HisNavigationService } from '../../core/service/base/his-navigation.service';
import { HisAuthService } from '../../auth/service/his-auth.service';
import { inject } from '@angular/core';

export function hisCanActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    let hisNavigationService = inject(HisNavigationService);
    let router = inject(Router);

    if (!route.data || !route.data.modules || (!route.data.hasAll && !route.data.hasAny)) {
        router.navigate( ['/hisng/access-disabled'], {
            skipLocationChange: true
        } );
        alert('Entwicklungsfehler: In jeder Route für eine Komponente müssen modules und hasAny/hasAll definiert werden.');
        return false;
    }

    let enabled = isEnabled( route );
    if ( !enabled ) {
        router.navigate( ['/hisng/access-disabled'], {
            skipLocationChange: true
        } );
    }

    let granted = isGranted( route );
    if ( !granted ) {
        hisNavigationService.navigateToAccessDenied();
    }

    return enabled && granted;
}

function isEnabled( route: ActivatedRouteSnapshot ): boolean {
    let hisAuthService = inject(HisAuthService);
    let hisBaseGlobalsService = inject(HisBaseGlobalsService);
    let data = route.data as (Data & {modules: string[]; anonmodules: string[]});

    if ( hisAuthService.isAnonymous && data.anonmodules) {
        return hisBaseGlobalsService.isAnyModuleActive( ...data.anonmodules );
    }
    return hisBaseGlobalsService.isAnyModuleActive( ...data.modules );
}

function isGranted( route: ActivatedRouteSnapshot ): boolean {
    let hisAuthService = inject(HisAuthService);
    let data = route.data as (Data & {hasAll: string[]; hasAny: string[]});

    // check hasAll
    if ( data.hasAll ) {
        let granted = hisAuthService.hasAll( ...data.hasAll );
        if ( !granted ) {
            return false;
        }
    }

    // check hasAny
    if ( data.hasAny ) {
        return hisAuthService.hasAny( ...data.hasAny );
    }

    // check hasAll was true, and hasAny was not defined
    return true;
}
